<template lang="pug">
.company-page
  el-row.company-container(:gutter='16')
    el-col.h-100(:span='8')
      div.left-part
        .title 企业列表
        .part-body
          .search
            el-form(:model="searchFormData" inline @submit.native.prevent)
              el-form-item(label="企业名称" prop="enterpriseName")
                el-input(v-model="searchEnterpriseName" placeholder="请输入企业名称" style="width: 235px;" clearable filterable @keyup.enter.native="searchEnterpriseHandle")
              el-form-item
                el-button.ml-1(type="primary" size="mini" @click="searchEnterpriseHandle" :loading="searchEnterpriseLoading") 查询
            <!--el-button(size="mini" @click="resetSearchEnterprise") 重置-->
          .enterprise-table.untp-table
            el-table(:data="enterpriseList" v-loading="treeLoading" element-loading-text='加载中...' element-loading-spinner="el-icon-loading" highlight-current-row @row-click='selectEnterprise'
                      height="100%" ref="enterpriseTable",border stripe)
              el-table-column(type="index" label="序号" width="80")
              el-table-column(label="企业名称" prop="enterpriseName")
              el-table-column(label="企业编码" prop="suNumber")
          el-pagination.mt-2.text-right(:pager-count="5" @size-change="enterpriseListPageSizeChange" @current-change="enterpriseListPageChange" :current-page="enterpriseListPage.pageNum"
                :page-sizes="[10, 20, 50]" :page-size="enterpriseListPage.pageSize" layout="total, sizes, prev, pager, next" :total="enterpriseListPage.total"
                style="overflow: auto;")
    el-col.h-100(:span="16")
      div.right-part
        .top-item
          .title 工厂配额
          .part-body
            .search-inline
              el-row.mb-2
                el-col(:span='12')
                  el-form(:model="searchFormData" inline @submit.native.prevent)
                    el-form-item(label="工厂名称" prop="enterpriseName")
                      el-input(v-model="searchFormData.enterpriseName" clearable placeholder="请输入工厂名称" filterable @keyup.enter.native="searchList")
                    el-form-item
                      el-button(type="primary" @click="searchList" :loading="searchLoading") 查询
                el-col(:span='12')
                  div.fr
                    el-button(type="primary" @click="editEnterpriseQuotaHandle(null,0,checkList)" ) 编辑
                    el-button(type="primary" @click="clearEnterpriseQuota(null,0,checkedList)" ) 重置
            .table.untp-table
              el-table(:data="pageEnterprise"  v-loading="tableLoading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" height="100%" border highlight-current-row
              tooltip-effect="light" @selection-change="handleSelectionChange")
                el-table-column(type='selection')
                el-table-column(type="index" label="序号" width="55")
                el-table-column(prop="enterpriseName" label="工厂名称")
                el-table-column(prop="enterpriseCode" label="工厂代码")
                el-table-column(prop="limitAmount" label="唯一码配额")
                el-table-column(prop="limitPercent" label="最低配额比例%" :formatter="formatMode")
                el-table-column(prop="expiryTime" label="有效期")
                el-table-column(prop="downloadCount" label="码下载配额" )
                el-table-column(label="操作")
                  template(slot-scope="scope")
                    el-button(type="text" @click="editEnterpriseQuotaHandle(scope.row,1,null)" ) 编辑
                    el-button(type="text" @click="clearEnterpriseQuota(scope.row,1,null)" ) 重置
                    el-button(type="text" @click="clearCodePool(scope.row)" ) 生成件码
                    el-button(type="text" @click="clearBoxPool(scope.row)" ) 生成箱码
              el-pagination.mt-2.text-right(:pager-count="5" @size-change="currentPageSizeChange" @current-change="currentPageChange" :current-page="enterpriseQuotaList.pageNum"
              :page-sizes="[5, 10, 20, 50]" :page-size="enterpriseQuotaList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="enterpriseQuotaList.total")
          el-dialog(title='工厂配额' :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px")
            .body
              el-form(:rules='dialogFormRules' :model="formData" label-width="120px" label-position="right" ref="limitForm")
                el-form-item(label="配额" prop="limitAmount")
                  el-input.w-300(v-model="formData.limitAmount" type="text" placeholder="请输入大于0的整数，例如：10000")
                el-form-item(label="最低配额比例" prop="limitPercent" )
                  el-input.w-300(v-model="formData.limitPercent" type="text" placeholder="请输入大于0的整数，例如：10")
                  span %
                el-form-item(label="有效期" prop="expiryTime")
                  el-date-picker.w-300(v-model='formData.expiryTime' align='right' value-format='yyyy-MM-dd' type='date' placeholder='选择日期' :picker-options="pickerOptions")
                el-form-item(label="码下载配额" prop="downloadCount")
                  el-input.w-300(v-model="formData.downloadCount" type="text" placeholder="请输入大于0的整数，例：100")
            span(slot="footer" class="dialog-footer")
              el-button(type="primary" @click="confirmHandler" :loadong="submitLoading") 确定
              el-button(@click="dialogVisible = false") 取消
</template>

<script>
  import { validateNumber } from "../../utils/validate.js";
  import * as api from "../../service/api/enterpriseApi";
  import _ from "lodash";
  import { createCodepool } from '../../service/api/barcodeApi.js';
  import { exists } from 'fs';
  export default {
    name: "enterpriseQuota",
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        searchLoading: false,
        tableLoading: false,
        searchEnterpriseLoading: false,
        treeLoading: false,
        searchEnterpriseName: '',
        parentId: '',
        enterpriseList: [],
        actionType: 0,
        pageEnterprise: [],
        checkList: [],
        enterpriseQuotaList: {
          pageSize: 10,
          pageNum: 1,
          total: 0
        },
        enterpriseListPage: {
          pageSize: 10,
          pageNum: 1,
          total: 0
        },
        searchFormData: {
          enterpriseName: "",
        },
        formData: {
          limitAmount: "",
          limitPercent: "",
          enterpriseId: "",
          expiryTime: "",
          enterpriseName: "",
          downloadCount: "",
          enterpriseLimitId: ""
        },
        dialogFormRules: {
          limitAmount: [
            {
              required: true,
              trigger: "blur",
              message: "数量不允许为空"
            },
            {
              validator: validateNumber,
              isNegative: false,
              min: 0
            }
          ],
          limitPercent: [
            {
              required: true,
              trigger: "blur",
              message: "数量不允许为空"
            },
            {
              validator: validateNumber,
              isNegative: false,
              min: 0,
              max: 100
            }
          ],
          downloadCount: [
            {
              required: true,
              trigger: "blur",
              message: "数量不允许为空"
            },
            {
              validator: validateNumber,
              isNegative: false,
              min: 0
            }
          ],
          expiryTime: [
            {
              required: true,
              trigger: "blur",
              message: "时间不能为空"
            }
          ]
        },
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now();
          }
        }
      };
    },
    created() {
        // 获取企业列表数据
      this.getEnterpriseListData()
    },
    methods: {
      // 重置查询企业列表
    resetSearchEnterprise() {
      this.searchEnterpriseName = ''
      this.getEnterpriseListData()
    },
        // 查询企业列表数据
    searchEnterpriseHandle() {
      this.enterpriseListPage.pageNum = 1
      this.searchEnterpriseLoading = true
      this.getEnterpriseListData()
    },
        // 选择企业列表行
    selectEnterprise(row) {
      this.selectedTreeNodeData = row
      this.parentId = this.selectedTreeNodeData.enterpriseId
      this.searchList()
    },
        // 企业表page变化
    enterpriseListPageChange(page) {
      this.enterpriseListPage.pageNum = page
      this.getEnterpriseListData()
    },
           // 企业表pageSize变化
    enterpriseListPageSizeChange(pageSize) {
      this.enterpriseListPage.pageSize = pageSize
      this.enterpriseListPage.pageNum = 1
      this.getEnterpriseListData()
    },
     // 获取企业列表数据
    getEnterpriseListData() {
      this.treeLoading = true
      let type = ''
      let name = this.searchEnterpriseName.trim()
      let pageNum = this.enterpriseListPage.pageNum
      let pageSize = this.enterpriseListPage.pageSize
      api.getEnterpriseList(type, name, pageNum, pageSize).then(res => {
        this.enterpriseList = _.cloneDeep(res.data.list)
        this.enterpriseListPage.total = res.data.total
        if (this.enterpriseList.length) {
          this.selectEnterprise(this.enterpriseList[0])
          this.$refs.enterpriseTable && this.$refs.enterpriseTable.setCurrentRow(this.enterpriseList[0])
        }
        this.treeLoading = false
        this.searchEnterpriseLoading = false
      }).catch(() => {
        this.treeLoading = false
        this.searchEnterpriseLoading = false
      })
    },
      //勾选
      handleSelectionChange(checkedList) {
        this.checkList = checkedList;
      },
      //编辑
      editEnterpriseQuotaHandle(row, type, checkedList) {
        this.actionType = type;
        if (type === 0) {
          if (!this.checkList || !this.checkList.length) {
            this.$message.warning("请勾选列表");
            return;
          }
          this.formData.limitAmount = "";
          this.formData.limitPercent = "";
          this.formData.expiryTime = "";
          this.formData.downloadCount = "";
        } else {
          this.formData.limitAmount = row.limitAmount;
          if (row.limitPercent === null || row.limitPercent === "") {
            this.formData.limitPercent = row.limitPercent;
          } else {
            this.formData.limitPercent = row.limitPercent * 100;
          }
          this.formData.expiryTime = row.expiryTime;
          this.formData.downloadCount = row.downloadCount;
          this.formData.enterpriseId = row.enterpriseId;
          this.formData.enterpriseName = row.enterpriseName;
          this.formData.enterpriseLimitId = row.enterpriseLimitId;
        }
        this.$nextTick(() => {
          this.$refs.limitForm && this.$refs.limitForm.clearValidate()
        })
        this.dialogVisible = true;
      },
      //确定编辑
      confirmHandler() {
        this.submitLoading = true;
        this.$refs.limitForm.validate().then(() =>{
          let gatewayArr = [];
          if (this.actionType === 0) {
            this.checkList.forEach(item => {
              gatewayArr.push({
                limitAmount: this.formData.limitAmount,
                limitPercent: this.formData.limitPercent / 100,
                expiryTime: this.formData.expiryTime,
                downloadCount: this.formData.downloadCount,
                enterpriseId: item.enterpriseId,
                enterpriseLimitId: item.enterpriseLimitId
              });
            });
          } else {
            gatewayArr.push({
              limitAmount: this.formData.limitAmount,
              limitPercent: this.formData.limitPercent / 100,
              expiryTime: this.formData.expiryTime,
              downloadCount: this.formData.downloadCount,
              enterpriseId: this.formData.enterpriseId,
              enterpriseLimitId: this.formData.enterpriseLimitId
            });
          }
          api.editEnterpriseQuota(gatewayArr).then(() => {
            this.submitLoading = false;
            this.$message.success("操作成功");
            this.dialogVisible = false;
            this.getEnterpriseQuotaList();
          }).catch(() => {
            this.submitLoading = false;
          });
          this.dialogVisible = false;
         }).catch(() => {})

      },
      //创建件码码池
      clearCodePool(row){
        this.$confirm('是否现在生成件码码池？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        }).then(() => {
        let params ={
                enterpriseCode : row.enterpriseCode,
                codeType : 'code',
                supplierCode:this.selectedTreeNodeData.suNumber
        };
        createCodepool(params).then((result) => {
          if(result.code == 500){
          this.$message.success(result.message);
          }else{
             this.$message.success('申请已提交，请稍后!');
          }
          }).catch(() => {
             this.$message.error('请求异常，请重试!');
          })
        }).catch(() => {
        })
      },

      //创建箱码码码池
      clearBoxPool(row){
        this.$confirm(
        '是否现在生成箱码码池？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let params ={
                    enterpriseCode : row.enterpriseCode,
                    codeType : 'box',
                    supplierCode : this.selectedTreeNodeData.suNumber
            };
            createCodepool(params).then((result) => {
              if(result.code == 500){
              this.$message.success(result.message);
              }else{
                 this.$message.success('申请已提交，请稍后!');
              }
            }).catch(() => {
               this.$message.error('请求异常，请重试!');
            })
        }).catch(() => {
        })
      },

      //重置
      clearEnterpriseQuota(row, type, checkedList){
        this.$confirm('数据重置后不可恢复，确认重置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        }).then(() => {
        let enterpriseLimitIds
        if(type === 0){
          if (!this.checkList || !this.checkList.length) {
            this.$message.warning("请勾选列表");
            return;
          }
          enterpriseLimitIds = this.checkList.map(item => item.enterpriseLimitId).join(',')
        }else{
          enterpriseLimitIds = row.enterpriseLimitId
        }
        if(!enterpriseLimitIds || !enterpriseLimitIds.length){
          this.$message.success("重置成功");
          return;
        }
        api.removeEnterpriseLimit(enterpriseLimitIds).then(() => {
          this.getEnterpriseQuotaList();
          this.$message.success('重置成功')
          })
        }).catch(() => {})
      },
      // 查询
      searchList() {
        this.enterpriseQuotaList.pageNum = 1;
        this.searchLoading = true;
        this.getEnterpriseQuotaList();
      },
      // pageSize变化
      currentPageSizeChange(pageSize) {
        this.enterpriseQuotaList.pageSize = pageSize;
        this.enterpriseQuotaList.pageNum = 1;
        this.getEnterpriseQuotaList();
      },
      currentPageChange(pageNum) {
        this.enterpriseQuotaList.pageNum = pageNum;
        this.getEnterpriseQuotaList();
      },
      //查询企业配额列表
      getEnterpriseQuotaList() {
        let params = {
          parentId: this.parentId,
          enterpriseName: this.searchFormData.enterpriseName.trim(),
          pageNum: this.enterpriseQuotaList.pageNum,
          pageSize: this.enterpriseQuotaList.pageSize
        };
        this.tableLoading = true;
        api.pageEnterpriseQuota(params).then(res => {
          if (res.data) {
            this.pageEnterprise = _.cloneDeep(res.data.list);
            this.enterpriseQuotaList.total = res.data.total;
          }
          this.tableLoading = false;
          this.searchLoading = false;
        }).catch(() => {
          this.searchLoading = false;
          this.tableLoading = false;
        });
      },
      formatMode(row, col) {
        if (col.label === "最低配额比例%") {
          if (row[col.property] == 0) {
            return 0;
          } else {
            var str = Number(row[col.property] * 100).toFixed();
            str += "%";
            return str;
          }
        }
      }
    }
  };
</script>
<style scoped lang="scss">
.searchUser {
  padding-bottom: 20px;
}
.company-page {
  height: 100%;
  width: 100%;
  padding: 16px 0 16px 16px;
  min-height: 600px;
	min-width: 1000px;
  .company-container {
    height: 100%;
    width: 100%;
    .left-part {
      background-color: #fff;
      height: 100%
    }
    .right-part {
      height: 100%;
      .top-item {
        background-color: #fff;
        height: 100%;
      }
    }
     .title {
        font-size: 16px;
        font-family: 'MicrosoftYaHei';
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        border-bottom: 1px solid #f1f1f1;
        padding: 15px;
        margin-bottom: 15px;
      }
    .part-body {
      padding: 0 24px;
      height: calc(100% - 70px);
     
      .search {
        display: flex;
      }
      .tree {
        margin-top: 20px;
        height: calc(100% - 170px);
        overflow: auto;
      }
      .table {
        height: calc(100% - 170px);
      }
      .enterprise-table {
        margin-top: 20px;
        height: calc(100% - 170px);
      }
    }
  }
}
.container {
  .dataTable {
    margin-top: 20px;
    padding-bottom: 20px;
  }
}
</style>
